var _path, _g, _path2, _rect, _rect2, _path3, _rect3, _rect4, _path4, _rect5, _rect6, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 23C29 19.6863 31.6863 17 35 17H125C128.314 17 131 19.6863 131 23V139C131 142.314 128.314 145 125 145H35C31.6863 145 29 142.314 29 139V23Z",
    fill: "#1E95F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 23C34 22.4477 34.4477 22 35 22H125C125.552 22 126 22.4477 126 23V116L102 140H35C34.4477 140 34 139.552 34 139V23Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 116H126L102 140V116Z",
    fill: "#E8F4FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 44,
    width: 39,
    height: 3,
    fill: "#1E4A77"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 50,
    width: 46,
    height: 3,
    fill: "#1E4A77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.834 48L49.5681 50.7341C49.6853 50.8513 49.8752 50.8513 49.9924 50.7341L55.6728 45.0537",
    stroke: "#00C4AC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 64,
    width: 39,
    height: 3,
    fill: "#1E4A77"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 70,
    width: 46,
    height: 3,
    fill: "#1E4A77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.834 68L49.5681 70.7341C49.6853 70.8513 49.8752 70.8513 49.9924 70.7341L55.6728 65.0537",
    stroke: "#00C4AC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 84,
    width: 39,
    height: 3,
    fill: "#1E4A77"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 90,
    width: 46,
    height: 3,
    fill: "#1E4A77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.834 88L49.5681 90.7341C49.6853 90.8513 49.8752 90.8513 49.9924 90.7341L55.6728 85.0537",
    stroke: "#00C4AC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 10C82.7614 10 85 12.2386 85 15H103V23C103 24.1046 102.105 25 101 25H59C57.8954 25 57 24.1046 57 23V15H75C75 12.2386 77.2386 10 80 10ZM80 17C81.1046 17 82 16.1046 82 15C82 13.8954 81.1046 13 80 13C78.8954 13 78 13.8954 78 15C78 16.1046 78.8954 17 80 17Z",
    fill: "#A5D5FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 31,
    y: 20,
    width: 98,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.137255 0 0 0 0 0.258824 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTasks);
export default __webpack_public_path__ + "static/media/empty-tasks.61cfdf8b.svg";
export { ForwardRef as ReactComponent };